import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { ReceiptHeader } from '../common/types';
import { postItem } from '../queries/queries';

type PostSscc = {
  payload?: ReceiptHeader;
  error: string;
};

type CompleteSsccResponse = {
  postItem: string;
};

export async function postSscc(body: string): Promise<PostSscc> {
  const genericResponseError = {
    payload: undefined,
    error: 'An error occurred while creating a job.'
  };
  try {
    const result = (await API.graphql(graphqlOperation(postItem, { body }))) as GraphQLResult<CompleteSsccResponse>;

    if (result.data && result.data.postItem) {
      const poResult = JSON.parse(result.data.postItem);
      if (poResult.statusCode === 200) {
        return { payload: poResult.body, error: '' };
      }
    }
    return genericResponseError;
  } catch (e) {
    console.error('Error posting sscc: ', e);
    return genericResponseError;
  }
}
